// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCasesRequestModel {
    static getAttributeTypeMap() {
        return GetCasesRequestModel.attributeTypeMap;
    }
}
GetCasesRequestModel.discriminator = undefined;
GetCasesRequestModel.additionalProperties = false;
GetCasesRequestModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
];
//# sourceMappingURL=getCasesRequestModel.js.map